import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import CardSection from './CardSection';
import ChartSection from './ChartSection';
import FAQSections from './FAQSections';
import ReviewSection from './ReviewSection';
import { OuterLayout } from '../styles/Layouts';

function Home() {
  return (
    <HomeStyled>
      <Header />
      <OuterLayout>
        <CardSection />
        <ChartSection />
        <ReviewSection />
        <FAQSections />
      </OuterLayout>
    </HomeStyled>
  );
}

const HomeStyled = styled.section``;

export default Home;
